import { createContext, useContext, useState, useCallback, useMemo, type ReactNode } from 'react';

interface CallStateContextValue {
  isCallActive: boolean;
  setCallActive: (active: boolean) => void;
}

const CallStateContext = createContext<CallStateContextValue | undefined>(undefined);

export function CallStateProvider({ children }: { children: ReactNode }) {
  const [isCallActive, setIsCallActive] = useState(false);

  const setCallActive = useCallback((active: boolean) => {
    setIsCallActive(active);
  }, []);

  const value = useMemo(() => ({ isCallActive, setCallActive }), [isCallActive, setCallActive]);

  return (
    <CallStateContext.Provider value={value}>
      {children}
    </CallStateContext.Provider>
  );
}

export function useCallState() {
  const context = useContext(CallStateContext);
  if (!context) {
    throw new Error('useCallState must be used within a CallStateProvider');
  }
  return context;
}

export function useCallStateSafe() {
  return useContext(CallStateContext);
}
